import script from "./PosLeftbar.vue?vue&type=script&setup=true&lang=js"
export * from "./PosLeftbar.vue?vue&type=script&setup=true&lang=js"

import "./PosLeftbar.vue?vue&type=style&index=0&id=4bf079c3&scoped=true&lang=css"
import "./PosLeftbar.vue?vue&type=style&index=1&id=4bf079c3&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4bf079c3"]])

export default __exports__